import { Text, TextProps } from '@mantine/core';

export interface IDescriptionTextProps extends TextProps {
  children: React.ReactNode;
}

/** @registry Small dimmed Text preset for helper/description copy under a form field or heading. */
export const DescriptionText: React.FC<IDescriptionTextProps> = ({
  children,
  ...props
}) => {
  return (
    <Text c="dimmed" size="xs" mt="sm" ml="xs" {...props}>
      {children}
    </Text>
  );
};
